const API_BASE = (import.meta.env.VITE_API_URL ?? "").replace(/\/+$/, "");

/** Uploaded files come back as API-relative paths ("/public/images/x.png"). */
export function resolveMediaUrl(url?: string | null): string | undefined {
  if (!url) return undefined;
  if (/^(https?:|data:|blob:)/.test(url)) return url;
  return `${API_BASE}${url.startsWith("/") ? "" : "/"}${url}`;
}
